export const TRANSLATIONS_EN = {
    welcome:"Welcome",    
    login_login: "Log In",
    login_username: "Username",
    login_password: "Password",
    login_noaccount: "Don't have an account? Sign Up",
    login_remember_me: "Remember me",
    login_forgot_pass: "Forgot your password?",
    save_form_button: "Save",
    update_form_button: "Update",
    client_table_title: "Client",
    invoice_table_title: "Invoice",
    header_goToDoc: "Go to documentation",
    main_website: "Your Website",    
    menu_process: "Processes",
    menu_authenticate: "Authenticate",
    menu_invoice: "Invoicing",
    menu_purchase: "Purchases",
    menu_cash: "Cash",
    menu_inventory: "Stock",
    menu_tables: "Tables",
    menu_client: "Client",
    menu_provider: "Providers",
    menu_product_category: "Product Categories",
    menu_product: "Products",
    menu_employee: "Employees",
    menu_report: "Reports",
    menu_report_sales: "Sales",
    menu_report_purchase: "Purchases",
    menu_report_cash: "Casg",
    menu_report_inventory: "Stock",
    menu_purchases: "Purchases",
    menu_sales: "Invoices",
    menu_setting: "Setting",
    menu_settings: "System",
    menu_users: "User",
    menu_permissions: "Permissions",
    product_form_lbl_category: "Category",
    product_form_lbl_prod_code: "Code",
    product_form_lbl_prod_name: "Name",
    product_form_lbl_prod_price: "Price",
    product_form_lbl_dct: "Discount",
    product_form_lbl_tax: "Tax",
    product_form_lbl_barcode: "Bar Code",
    product_form_lbl_stock: "Stock",
    product_table_title: "Product",
    product_table_column_code: "Code",
    product_table_column_name: "Name",
    product_table_column_category: "Category",
    product_table_column_price: "Price",
    product_table_column_stock: "Stock",
    product_category_table_title: "Categories",
    product_category_table_column_name: "Name",
    product_form_lbl_prod_format:"Format",
    product_form_lbl_cost: "Cost",
    product_table_column_format: "Format",
    record_created_successfully: "{{table}} Created successfully!",
    record_updated_successfully: "{{table}} Updated successfully!"
   };